var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgUsdc(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "USDC",
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "USD_Coin_USDC_",
    "data-name": "USD Coin (USDC)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Elipse_737",
    "data-name": "Elipse 737",
    cx: 12,
    cy: 12,
    r: 12,
    fill: "#2e79cc"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_15261",
    "data-name": "Grupo 15261",
    transform: "translate(3.51 3.853)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Caminho_14516",
    "data-name": "Caminho 14516",
    d: "M79.853,60.2c0-1.623-.968-2.185-2.912-2.41-1.384-.19-1.661-.553-1.661-1.209s.466-1.068,1.391-1.068a1.369,1.369,0,0,1,1.528.977.356.356,0,0,0,.329.237h.727a.32.32,0,0,0,.322-.312v-.021a2.308,2.308,0,0,0-2.083-1.9V53.341c0-.183-.138-.32-.37-.371h-.729c-.182,0-.32.138-.364.371v1.068a2.365,2.365,0,0,0-2.271,2.267c0,1.53.924,2.136,2.868,2.366,1.3.225,1.718.51,1.718,1.245a1.362,1.362,0,0,1-1.528,1.253c-1.209,0-1.623-.51-1.762-1.2a.336.336,0,0,0-.328-.276H73.97a.313.313,0,0,0-.32.306v.058a2.585,2.585,0,0,0,2.468,2.229v1.118c0,.183.138.32.371.364h.727a.393.393,0,0,0,.371-.364V62.659A2.542,2.542,0,0,0,79.9,60.205Z",
    transform: "translate(-68.42 -50.537)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_14517",
    "data-name": "Caminho 14517",
    d: "M35.576,46.963a6.931,6.931,0,0,1,0-13.04.475.475,0,0,0,.276-.466V32.83a.356.356,0,0,0-.276-.363.263.263,0,0,0-.189.051,8.336,8.336,0,0,0,0,15.887.284.284,0,0,0,.388-.1.289.289,0,0,0,.034-.089c.043-.043.043-.087.043-.182v-.648A.6.6,0,0,0,35.576,46.963ZM40.484,32.51a.278.278,0,0,0-.381.094.262.262,0,0,0-.034.089c-.044.051-.044.095-.044.189v.648a.608.608,0,0,0,.276.459,6.931,6.931,0,0,1,0,13.019.466.466,0,0,0-.276.466v.648a.356.356,0,0,0,.276.371.265.265,0,0,0,.183-.051,8.367,8.367,0,0,0,0-15.932Z",
    transform: "translate(-29.58 -32.465)",
    fill: "#fff"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUsdc);
export default __webpack_public_path__ + "static/media/USDC.2b7e51fa2f4844521388db20e12270d5.svg";
export { ForwardRef as ReactComponent };